import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '.'

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    isLoading: false,
    isApiLoading: false,
    user: null,
    profile: null,
    showHeader: true,
    showFooter: true,
    showBanner: false,
  },
  reducers: {
    setUser: (state, action) => {
      if (action.payload) {
        state.user = { ...action.payload }
      } else {
        state.user = null
      }
    },
    setProfile: (state, action) => {
      if (action.payload) {
        state.profile = { ...action.payload }
      } else {
        state.profile = null
      }
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setIsApiLoading: (state, action) => {
      state.isApiLoading = action.payload
    },
  },
})

export const {
  setUser,
  setProfile,
  setIsLoading,
  setIsApiLoading,
} = appSlice.actions

export const currentUser = (state: RootState) => state.app.user
export const getProfile = (state: RootState) => state.app.profile
export const getIsLoading = (state: RootState) => state.app.isLoading
export const getIsApiLoading = (state: RootState) => state.app.isApiLoading

export default appSlice.reducer
